import { parseMonth, parseDateString, daysDifference } from './dateUtils';

// Mapping for LHR Source (keeping existing logic)
const LHR_SOURCE_MAP = {
  'Channel Partner - Sanjay S': 'CP Design',
  'Channel Partner - Vignesh': 'CP Factory',
  'Channel Partner - Vishal Pune': 'CP IMOS',
  'CP _ Shadab Nawaz _Kolkota': 'CP Operations',
  'CP_ Bharati Ghosh_Kolkata': 'CP I I',
  'CP_ Pappu Yadav_Kolkata': 'CP',
  'CP_ Prasanth M_Hyd': 'CP',
  'CP_Bharathan_Coimbatore': 'CP',
  'CP_Binu Rabidas_ Kolkata': 'CP',
  'CP_Estate guru_chennai': 'CP',
  'CP_Kotesh_Hyd': 'CP',
  'CP_Sathya Kumar_Hyd': 'CP',
  'CP_Tejus_Blr': 'CP',
  'CP_Vijaykumar_Hyd': 'CP',
  'CP-Abhilash-Blr': 'CP',
  'CP-Jyothi': 'CP',
  'CP-nextceiling-Blr': 'CP',
  'CP-Preeti Raghava': 'CP',
  'CP-Rajveer Tatar': 'CP',
  'Cp-Sateesh-Hyd': 'CP',
  'Cp-Souvik Chakraborty-Kolkota': 'CP',
  'CP-Sunil Kumar-Blr': 'CP',
  'chat': 'Digital',
  'Digital Chat - Paid': 'Digital',
  'Digital Direct call': 'Digital',
  'Digital Facebook': 'Digital',
  'Digital Facebook Lead Gen': 'Digital',
  'Digital Google call': 'Digital',
  'Digital Instagram': 'Digital',
  'Digital My Operator - Blank': 'Digital',
  'Digital My Operator - Marketing new interiors': 'Digital',
  'Digital N/A': 'Digital',
  'Digital Others': 'Digital',
  'Digital Partnership': 'Digital',
  'Digital Quikr': 'Digital',
  'Digital Website': 'Digital',
  'Digital Whatsapp': 'Digital',
  'Digital BotWot - Chat': 'Digital-Botwot',
  'BotWot - Facebook': 'Digital-Botwot',
  'BotWot - Instagram': 'Digital-Botwot',
  'BotWot - WhatsApp': 'Digital-Botwot',
  'Reference': 'Reference',
  'Reference Client Reference': 'Reference',
  'Reference Employee Reference': 'Reference',
  'Walk-In': 'Walk-In',
};

const DEPT_TO_STAGE_MAP = {
  'CP Design': '9- SalesWon',
  'CP Factory': '9- SalesWon',
  'CP IMOS': '9- SalesWon',
  'CP Operations': '9- SalesWon',
  'CP I I': 'CP I I',
  'CP': 'CP',
  'Digital': 'Digital',
  'Digital-Botwot': 'Digital-Botwot',
  'Reference': 'Reference',
  'Walk-In': 'Walk-In',
};

const CURRENT_STAGE_MAP = {
  'Designer Assignment Pending': '9- SalesWon',
  'Hold': '1-Marketing',
  'Junk': '1-Marketing',
  'Lead Received': '2-LR',
  'Lost': '8-Lost',
  'NA': '3-RNC',
  'Negotiation': '6-S/O Visit+Nego',
  'Won Deals Pending Designer Assignment': '9- SalesWon',
  'Requirements Collected': '4-RC',
  'Requirements Not Collected': '3-RNC',
  'Site/Office visit': '6-S/O Visit+Nego',
  'To Be Called': '1-Marketing',
  'Assign To IMOS User & Site BOM Completed': '9- SalesWon',
  'Assign To IMOS User & Site BOM In-progress': '9- SalesWon',
  'Quotation Sent': '5-QS',
  'Completed': '9- SalesWon',
  'Completed-MWP': '9- SalesWon',
  'Design Discussion': '9- SalesWon',
  'Design Kick-Off : Customer': '9- SalesWon',
  'Design Kick-Off : Internal': '9- SalesWon',
  'Design Sign-off': '9- SalesWon',
  'Designer Assigned': '9- SalesWon',
  'Drawing QC': '9- SalesWon',
  'Final Quote and Design': '9- SalesWon',
  'Finalization of Design': '9- SalesWon',
  'Finalization of Materials': '9- SalesWon',
  'IMOS Completed': '9- SalesWon',
  'IMOS Drawing In-Progress': '9- SalesWon',
  'Initial Measurement': '9- SalesWon',
  'Internal Design Sign-Off': '9- SalesWon',
  'Material Dispatched (In-transit)': '9- SalesWon',
  'Material Issued': '9- SalesWon',
  'Renders': '9- SalesWon',
  'Site QC/Project Kick-Off': '9- SalesWon',
  'Under Execution': '9- SalesWon',
  'Under Procurement': '9- SalesWon',
  'Under Production - Fixing': '9- SalesWon',
  'Under Production - Machine': '9- SalesWon',
};

export const computeLHRDerivedFields = (data, months) => {
  return data.map(row => {
    const derived = { ...row };
    
    // Compute monthKey
    derived.monthKey = parseMonth(row['Lead Assigned Date']);
    
    // LHR Source
    const sourceOfLead = row['Source Of Lead'];
    derived['LHR Source'] = LHR_SOURCE_MAP[sourceOfLead] || sourceOfLead;
    
    // LHR Current Stage
    const dept = row.Department;
    const currentStage = row['Current Stage'];
    
    if (dept && DEPT_TO_STAGE_MAP[dept]) {
      derived['LHR Current Stage'] = DEPT_TO_STAGE_MAP[dept];
    } else if (currentStage && CURRENT_STAGE_MAP[currentStage]) {
      derived['LHR Current Stage'] = CURRENT_STAGE_MAP[currentStage];
    } else {
      derived['LHR Current Stage'] = currentStage;
    }
    
    // LHR Meeting Done
    const meetingDate = row['Meeting Date'];
    const lhrStage = derived['LHR Current Stage'];
    const stageBeforeLost = row['Stage before Lost'];
    
    // Check for actual date value (exclude '-' placeholder and empty/null values)
    const hasMeetingDate = meetingDate && meetingDate !== '-' && meetingDate !== '' && meetingDate !== null;
    
    if (hasMeetingDate) {
      derived['LHR Meeting Done'] = 'Yes';
    } else if (lhrStage === '6-S/O Visit+Nego' || (lhrStage && lhrStage.includes('SalesWon'))) {
      derived['LHR Meeting Done'] = 'Yes';
    } else if (lhrStage === '8-Lost' && stageBeforeLost) {
      if (stageBeforeLost.includes('Site/Office visit') || 
          stageBeforeLost.includes('Negotiation') || 
          stageBeforeLost.includes('Won Deals Pending Designer Assignment') ||
          stageBeforeLost.includes('Designer Assignment Pending')) {
        derived['LHR Meeting Done'] = 'Yes';
      } else {
        derived['LHR Meeting Done'] = 'No';
      }
    } else {
      derived['LHR Meeting Done'] = 'No';
    }
    
    // LHR Quotation Sent
    const quotationDate = row['Quotation Sent Movement Date'];
    
    // Check for actual date value (exclude '-' placeholder and empty/null values)
    const hasQuotationDate = quotationDate && quotationDate !== '-' && quotationDate !== '' && quotationDate !== null;
    
    if (hasQuotationDate) {
      derived['LHR Quotation Sent'] = 'Yes';
    } else if (lhrStage === '5-QS' || lhrStage === '6-S/O Visit+Nego' || (lhrStage && lhrStage.includes('SalesWon'))) {
      derived['LHR Quotation Sent'] = 'Yes';
    } else if (lhrStage === '8-Lost' && stageBeforeLost) {
      if (stageBeforeLost.includes('Quotation Sent') || 
          stageBeforeLost.includes('Site/Office visit') || 
          stageBeforeLost.includes('Negotiation') ||
          stageBeforeLost.includes('Won Deals Pending Designer Assignment') ||
          stageBeforeLost.includes('Designer Assignment Pending')) {
        derived['LHR Quotation Sent'] = 'Yes';
      } else {
        derived['LHR Quotation Sent'] = 'No';
      }
    } else {
      derived['LHR Quotation Sent'] = 'No';
    }
    
    // LHR Stage Post Meeting - determines what happened after meeting
    // "2-SalesWon" if lead converted to sale, "3-Active" if still in pipeline
    if (lhrStage && lhrStage.includes('SalesWon')) {
      derived['LHR Stage Post Meeting'] = '2-SalesWon';
    } else if (lhrStage === '8-Lost') {
      derived['LHR Stage Post Meeting'] = '4-Lost';
    } else if (lhrStage === '5-QS' || lhrStage === '6-S/O Visit+Nego' || lhrStage === '7-Hot Deal') {
      // Active stages post-meeting
      derived['LHR Stage Post Meeting'] = '3-Active';
    } else if (lhrStage === '4-RC') {
      derived['LHR Stage Post Meeting'] = '3-Active';
    } else {
      derived['LHR Stage Post Meeting'] = '1-PreMeeting';
    }
    
    // Meeting Month Key - for filtering by meeting date
    if (hasMeetingDate) {
      derived.meetingMonthKey = parseMonth(meetingDate);
    } else {
      derived.meetingMonthKey = null;
    }
    
    // LHR Dates - Calculate days based on stage
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    
    if (lhrStage === '2-LR') {
      // For 2-LR: Today - Lead Assigned Date
      const leadAssignedDate = parseDateString(row['Lead Assigned Date']);
      derived['LHR Dates'] = leadAssignedDate ? daysDifference(leadAssignedDate, today) : null;
    } else if (lhrStage === '3-RNC') {
      // For 3-RNC: Today - Lead Assigned Date
      const leadAssignedDate = parseDateString(row['Lead Assigned Date']);
      derived['LHR Dates'] = leadAssignedDate ? daysDifference(leadAssignedDate, today) : null;
    } else if (lhrStage === '4-RC') {
      // For 4-RC: Today - Requirements Collected Stage Movement Date
      const rcMovementDate = parseDateString(row['Requirements Collected Stage Movement Date']);
      derived['LHR Dates'] = rcMovementDate ? daysDifference(rcMovementDate, today) : null;
    } else {
      derived['LHR Dates'] = null;
    }
    
    return derived;
  });
};

export const generateLHRTables = (data, months, groupBy = 'city') => {
  const groups = {};
  const groupField = groupBy === 'ec' ? 'Experience Center' : 'City';
  const groupLabel = groupBy === 'ec' ? 'EC Name' : 'City';
  
  // Group by selected field
  data.forEach(row => {
    const groupValue = row[groupField] || 'Unknown';
    if (!groupValue || groupValue === 'Unknown') return;
    if (!groups[groupValue]) groups[groupValue] = [];
    groups[groupValue].push(row);
  });
  
  const table1 = [];
  const table2 = [];
  const table3 = [];
  const table4 = [];
  const table5 = [];
  
  // Sort group names alphabetically
  Object.keys(groups).sort().forEach(groupName => {
    const groupData = groups[groupName];
    
    // Filter by month (based on Lead Assigned Date)
    const cm2Data = groupData.filter(r => r.monthKey === months.CM2);
    const cm1Data = groupData.filter(r => r.monthKey === months.CM1);
    const cmData = groupData.filter(r => r.monthKey === months.CM);
    
    // Calculate counts for each period
    // Closures (LHR Current Stage contains "SalesWon")
    const closureCM2 = cm2Data.filter(r => {
      const stage = r['LHR Current Stage'];
      return stage && (stage.includes('9-SalesWon') || stage.includes('9- SalesWon') || stage === '9-SalesWon');
    }).length;
    const closureCM1 = cm1Data.filter(r => {
      const stage = r['LHR Current Stage'];
      return stage && (stage.includes('9-SalesWon') || stage.includes('9- SalesWon') || stage === '9-SalesWon');
    }).length;
    const closureCM = cmData.filter(r => {
      const stage = r['LHR Current Stage'];
      return stage && (stage.includes('9-SalesWon') || stage.includes('9- SalesWon') || stage === '9-SalesWon');
    }).length;
    
    // Right Side (6-S/O Visit+Nego OR 5-QS)
    const rightCM2 = cm2Data.filter(r => ['6-S/O Visit+Nego', '5-QS'].includes(r['LHR Current Stage'])).length;
    const rightCM1 = cm1Data.filter(r => ['6-S/O Visit+Nego', '5-QS'].includes(r['LHR Current Stage'])).length;
    const rightCM = cmData.filter(r => ['6-S/O Visit+Nego', '5-QS'].includes(r['LHR Current Stage'])).length;
    
    // Left Side (2-LR, 3-RNC, 4-RC)
    const leftCM2 = cm2Data.filter(r => ['2-LR', '3-RNC', '4-RC'].includes(r['LHR Current Stage'])).length;
    const leftCM1 = cm1Data.filter(r => ['2-LR', '3-RNC', '4-RC'].includes(r['LHR Current Stage'])).length;
    const leftCM = cmData.filter(r => ['2-LR', '3-RNC', '4-RC'].includes(r['LHR Current Stage'])).length;
    
    // Lost (8-Lost)
    const lostCM2 = cm2Data.filter(r => r['LHR Current Stage'] === '8-Lost').length;
    const lostCM1 = cm1Data.filter(r => r['LHR Current Stage'] === '8-Lost').length;
    const lostCM = cmData.filter(r => r['LHR Current Stage'] === '8-Lost').length;
    
    // Meeting Done (with AND operator: assigned in period AND meeting done = Yes)
    const meetingCM2 = cm2Data.filter(r => r['LHR Meeting Done'] === 'Yes').length;
    const meetingCM1 = cm1Data.filter(r => r['LHR Meeting Done'] === 'Yes').length;
    const meetingCM = cmData.filter(r => r['LHR Meeting Done'] === 'Yes').length;
    
    // Quotation Sent (with AND operator: assigned in period AND quotation sent = Yes)
    const quotationCM2 = cm2Data.filter(r => r['LHR Quotation Sent'] === 'Yes').length;
    const quotationCM1 = cm1Data.filter(r => r['LHR Quotation Sent'] === 'Yes').length;
    const quotationCM = cmData.filter(r => r['LHR Quotation Sent'] === 'Yes').length;
    
    // Company Expectations (based on definitions) - rounded to 2 decimal places
    const expectClosureCM2 = Math.round(cm2Data.length * 0.20 * 100) / 100;
    const expectClosureCM1 = Math.round(cm1Data.length * 0.15 * 100) / 100;
    const expectClosureCM = Math.round(cmData.length * 0.08 * 100) / 100;
    
    const expectMeetingCM2 = Math.round(meetingCM2 * 0.50 * 100) / 100;
    const expectMeetingCM1 = Math.round(meetingCM1 * 0.50 * 100) / 100;
    const expectMeetingCM = Math.round(meetingCM * 0.50 * 100) / 100;
    
    // Table 1: Lead Pipeline
    const t1Row = {
      [groupLabel]: groupName,
      'Lead Assigned. - Current Month - 2 (CM-2)': cm2Data.length,
      'Lead Closure from (CM-2)': closureCM2,
      'Lead Right Side - (CM-2)': rightCM2,
      'Lead Left Side - (CM-2)': leftCM2,
      'Lead Lost - (CM-2)': lostCM2,
      'Lead Assigned. - Current Month - 1 (CM-1)': cm1Data.length,
      'Lead Closure from (CM-1)': closureCM1,
      'Lead Right Side - (CM-1)': rightCM1,
      'Lead Left Side - (CM-1)': leftCM1,
      'Lead Lost - (CM-1)': lostCM1,
      'Lead Assigned. - Current Month (CM)': cmData.length,
      'Lead Closure from (CM)': closureCM,
      'Lead Right Side - (CM)': rightCM,
      'Lead Left Side - (CM)': leftCM,
      'Lead Lost - (CM)': lostCM,
    };
    table1.push(t1Row);
    
    // Table 2: Lead 2 Closure and Addn Closure
    // Additional closure = Company Expectation - Actual Closure (the additional closures needed to meet target)
    const addnClosureCM2 = Math.round((expectClosureCM2 - closureCM2) * 100) / 100;
    const addnClosureCM1 = Math.round((expectClosureCM1 - closureCM1) * 100) / 100;
    const addnClosureCM = Math.round((expectClosureCM - closureCM) * 100) / 100;
    
    const t2Row = {
      [groupLabel]: groupName,
      'Lead Assigned. - Current Month - 2 (CM-2)': cm2Data.length,
      'Lead Assigned. - Current Month - 1 (CM-1)': cm1Data.length,
      'Lead Assigned. - Current Month (CM)': cmData.length,
      'Additional closure from Lead Assigned. - Current Month - 2 (CM-2)': addnClosureCM2,
      'Additional closure from Lead Assigned. - Current Month - 1 (CM-1)': addnClosureCM1,
      'Additional closure from Lead Assigned. - Current Month (CM)': addnClosureCM,
      'Closure from (CM-2)': closureCM2,
      'Closure from (CM-1)': closureCM1,
      'Closure from (CM)': closureCM,
      'Company Expectation: Closure from (CM-2) Lead (20%)': expectClosureCM2,
      'Company Expectation: Closure from (CM-1) Lead (15%)': expectClosureCM1,
      'Company Expectation: Closure from (CM) Lead (8%)': expectClosureCM,
    };
    table2.push(t2Row);
    
    // Table 3: Lead 2 Meeting and Meeting 2 Closure
    // Closures from Meeting done: Assigned in period AND Meeting Done = Yes AND SalesWon
    const closureFromMeetingCM2 = cm2Data.filter(r => 
      r['LHR Meeting Done'] === 'Yes' &&
      r['LHR Stage Post Meeting'] && r['LHR Stage Post Meeting'].includes('SalesWon')
    ).length;
    const closureFromMeetingCM1 = cm1Data.filter(r => 
      r['LHR Meeting Done'] === 'Yes' &&
      r['LHR Stage Post Meeting'] && r['LHR Stage Post Meeting'].includes('SalesWon')
    ).length;
    const closureFromMeetingCM = cmData.filter(r => 
      r['LHR Meeting Done'] === 'Yes' &&
      r['LHR Stage Post Meeting'] && r['LHR Stage Post Meeting'].includes('SalesWon')
    ).length;
    
    // Active Leads from Meeting Done: Assigned in period AND Meeting Done = Yes AND Active
    const activeFromMeetingCM2 = cm2Data.filter(r => 
      r['LHR Meeting Done'] === 'Yes' &&
      r['LHR Stage Post Meeting'] === '3-Active'
    ).length;
    const activeFromMeetingCM1 = cm1Data.filter(r => 
      r['LHR Meeting Done'] === 'Yes' &&
      r['LHR Stage Post Meeting'] === '3-Active'
    ).length;
    const activeFromMeetingCM = cmData.filter(r => 
      r['LHR Meeting Done'] === 'Yes' &&
      r['LHR Stage Post Meeting'] === '3-Active'
    ).length;
    
    // Additional closure from Meeting = (Meeting Done * 50%) - Closures from Meeting
    const addnClosureFromMeetingCM2 = Math.round((expectMeetingCM2 - closureFromMeetingCM2) * 100) / 100;
    const addnClosureFromMeetingCM1 = Math.round((expectMeetingCM1 - closureFromMeetingCM1) * 100) / 100;
    const addnClosureFromMeetingCM = Math.round((expectMeetingCM - closureFromMeetingCM) * 100) / 100;
    
    const t3Row = {
      [groupLabel]: groupName,
      'Lead Assigned. - Current Month - 2 (CM-2)': cm2Data.length,
      'Lead Assigned. - Current Month - 1 (CM-1)': cm1Data.length,
      'Lead Assigned. - Current Month (CM)': cmData.length,
      'Additional closure from Meeting done from (CM-2)': addnClosureFromMeetingCM2,
      'Additional closure from Meeting done from (CM-1)': addnClosureFromMeetingCM1,
      'Additional closure from Meeting done from (CM)': addnClosureFromMeetingCM,
      'Lead Meeting done from (CM-2)': meetingCM2,
      'Lead Meeting done from (CM-1)': meetingCM1,
      'Lead Meeting done from (CM)': meetingCM,
      'Closures from Meeting done in (CM-2)': closureFromMeetingCM2,
      'Closures from Meeting done in (CM-1)': closureFromMeetingCM1,
      'Closures from Meeting done in (CM)': closureFromMeetingCM,
      'Active Leads from Meeting Done in (CM-2)': activeFromMeetingCM2,
      'Active Leads from Meeting Done in (CM-1)': activeFromMeetingCM1,
      'Active Leads from Meeting Done in (CM)': activeFromMeetingCM,
    };
    table3.push(t3Row);
    
    // Table 4: Lead to Quotation and Quotation to Closure
    const t4Row = {
      [groupLabel]: groupName,
      'Lead Assigned. - Current Month - 2 (CM-2)': cm2Data.length,
      'Lead Assigned. - Current Month - 1 (CM-1)': cm1Data.length,
      'Lead Assigned. - Current Month (CM)': cmData.length,
      'Quotation Shared from (CM-2)': quotationCM2,
      'Quotation Shared from (CM-1)': quotationCM1,
      'Quotation Shared from (CM)': quotationCM,
      'Closure from (CM-2)': closureCM2,
      'Closure from (CM-1)': closureCM1,
      'Closure from (CM)': closureCM,
    };
    table4.push(t4Row);
    
    // Table 5: Leads where tasks are not done properly (across all months)
    // Lead Received Criteria failed: stage = "2-LR" AND LHR Dates >= 1
    const lrCriteriaFailed = groupData.filter(r => 
      r['LHR Current Stage'] === '2-LR' && 
      r['LHR Dates'] !== null && 
      r['LHR Dates'] >= 1
    ).length;
    
    // RNC Criteria Failed: stage = "3-RNC" AND LHR Dates >= 5
    const rncCriteriaFailed = groupData.filter(r => 
      r['LHR Current Stage'] === '3-RNC' && 
      r['LHR Dates'] !== null && 
      r['LHR Dates'] >= 5
    ).length;
    
    // RC Criteria Failed: stage = "4-RC" AND LHR Dates >= 2
    const rcCriteriaFailed = groupData.filter(r => 
      r['LHR Current Stage'] === '4-RC' && 
      r['LHR Dates'] !== null && 
      r['LHR Dates'] >= 2
    ).length;
    
    // Quotation Send But HDCL not filled: stage = "5-QS" AND Cx Move-in Timeline contains "NA"
    const qsHdclNotFilled = groupData.filter(r => {
      const stage = r['LHR Current Stage'];
      const cxMoveIn = r['Cx Move-in Timeline'];
      return stage === '5-QS' && cxMoveIn && (cxMoveIn === 'NA' || cxMoveIn.toString().toUpperCase() === 'NA');
    }).length;

    const quotationMeetingNotFixed = groupData.filter(r => {
      if (r['Lead Type'] !== 'Real') return false;
      if (r['Current Stage'] !== 'Quotation Sent') return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const meetingDateStr = r['updateMeetingDetails'];

      // Empty check
      const isEmpty = !meetingDateStr || meetingDateStr === '-' || meetingDateStr === '';
      if (isEmpty) return true; 

      // Past check
      const meetingDate = parseDateString(meetingDateStr);
      const isInPast =
        meetingDate instanceof Date &&
        !isNaN(meetingDate) &&
        meetingDate < today; 

      return isInPast;
    }).length;

    
    const t5Row = {
      [groupLabel]: groupName,
      'Lead Received Criteria failed': lrCriteriaFailed,
      'RNC Criteria Failed': rncCriteriaFailed,
      'RC Criteria Failed': rcCriteriaFailed,
      'Quotation Send But HDCL not filled': qsHdclNotFilled,
      'Quotation Send, Meeting Not Fixed': quotationMeetingNotFixed
    };
    table5.push(t5Row);
  });
  
  // Add Total row to each table
  const addTotalRow = (table, groupLabel) => {
    if (table.length === 0) return table;
    
    const totalRow = { [groupLabel]: 'TOTAL' };
    const columns = Object.keys(table[0]);
    
    columns.forEach(col => {
      if (col === groupLabel) return;
      // Sum numeric values
      const sum = table.reduce((acc, row) => {
        const val = row[col];
        return acc + (typeof val === 'number' ? val : 0);
      }, 0);
      // Round to 2 decimal places if needed
      totalRow[col] = Math.round(sum * 100) / 100;
    });
    
    return [...table, totalRow];
  };
  
  return { 
    table1: addTotalRow(table1, groupLabel), 
    table2: addTotalRow(table2, groupLabel), 
    table3: addTotalRow(table3, groupLabel), 
    table4: addTotalRow(table4, groupLabel), 
    table5: addTotalRow(table5, groupLabel) 
  };
};

const DEFAULT_NOTES_PENDING_STAGES = [
  'Lead Received',
  'Requirements Not Collected',
  'Requirements Collected',
  'Quotation Sent',
  'Negotiation',
  'Won',
  'Lost',
];

export const NOTES_PENDING_MODAL_COLUMNS = [
  'Lead No.',
  'Lead Assigned Date',
  'Experience Center',
  'City',
  'Current Stage',
  'Assigned To',
  'Lead Type',
  'Source Of Lead',
  'Pending Days',
];

export const getNotesPendingStageColumns = (notesPendingData) => {
  if (Array.isArray(notesPendingData?.allowedStages) && notesPendingData.allowedStages.length > 0) {
    return notesPendingData.allowedStages;
  }
  return DEFAULT_NOTES_PENDING_STAGES;
};

const getNotesLeadGroupValue = (lead, groupBy) => {
  if (groupBy === 'ec') {
    return lead.experienceCenter || lead['Experience Center'] || 'Unknown';
  }
  return lead.city || lead.City || 'Unknown';
};

const getNotesLeadStage = (lead) => lead.currentStage || lead.salesStage || lead['Current Stage'] || '';

const buildNotesPendingRow = (groupLabel, groupName, stagesList, stageColumns) => {
  const stageMap = {};
  (stagesList || []).forEach(({ stage, count }) => {
    stageMap[stage] = Number(count) || 0;
  });

  const row = { [groupLabel]: groupName };
  let total = 0;
  stageColumns.forEach((stageCol) => {
    row[stageCol] = stageMap[stageCol] ?? 0;
    total += row[stageCol];
  });
  row.Total = total;
  return row;
};

const aggregateNotesPendingFromLeads = (leads, groupBy, groupLabel, stageColumns) => {
  const groups = {};

  leads.forEach((lead) => {
    const groupValue = getNotesLeadGroupValue(lead, groupBy);
    if (!groupValue || groupValue === 'Unknown') return;

    if (!groups[groupValue]) {
      groups[groupValue] = { [groupLabel]: groupValue };
      stageColumns.forEach((stageCol) => {
        groups[groupValue][stageCol] = 0;
      });
      groups[groupValue].Total = 0;
    }

    const stage = getNotesLeadStage(lead);
    if (stageColumns.includes(stage)) {
      groups[groupValue][stage] += 1;
    }
    groups[groupValue].Total += 1;
  });

  return Object.values(groups).sort((a, b) =>
    String(a[groupLabel]).localeCompare(String(b[groupLabel]))
  );
};

/** City / EC wise table for erp-leads-notes-pending API (uses summary.byCityAndStage) */
export const generateNotesPendingCityTable = (notesPendingData, groupBy = 'city') => {
  if (!notesPendingData) return [];

  const groupLabel = groupBy === 'ec' ? 'EC Name' : 'City';
  const stageColumns = getNotesPendingStageColumns(notesPendingData);
  const leads = Array.isArray(notesPendingData.leads) ? notesPendingData.leads : [];
  const byCityAndStage = notesPendingData.summary?.byCityAndStage;
  const useApiCitySummary =
    groupBy === 'city' &&
    Array.isArray(byCityAndStage) &&
    byCityAndStage.length > 0 &&
    notesPendingData._aggregatedFromLeads !== true;

  let rows = useApiCitySummary
    ? byCityAndStage.map((item) =>
        buildNotesPendingRow(groupLabel, item.city, item.stages, stageColumns)
      )
    : aggregateNotesPendingFromLeads(leads, groupBy, groupLabel, stageColumns);

  if (rows.length === 0) return [];

  const totalRow = { [groupLabel]: 'TOTAL' };
  [...stageColumns, 'Total'].forEach((col) => {
    totalRow[col] = rows.reduce((sum, row) => sum + (Number(row[col]) || 0), 0);
  });

  return [...rows, totalRow];
};

export const filterNotesPendingLeads = (notesPendingData, groupBy, groupValue, column) => {
  const leads = Array.isArray(notesPendingData?.leads) ? notesPendingData.leads : [];
  return leads.filter((lead) => {
    if (getNotesLeadGroupValue(lead, groupBy) !== groupValue) return false;
    if (column === 'Total') return true;
    return getNotesLeadStage(lead) === column;
  });
};

export const mapNotesPendingLeadsForModal = (leads) =>
  (leads || []).map((lead) => ({
    _id: lead._id,
    'Lead No.': lead.lead_no ?? lead['Lead No.'] ?? '-',
    'Lead Assigned Date': lead.leadAssignedDateDisplay || lead.leadAssignedDate || '-',
    'Experience Center': lead.experienceCenter || '-',
    City: lead.city || '-',
    'Current Stage': getNotesLeadStage(lead) || '-',
    'Assigned To': lead.assignToName || '-',
    'Lead Type': lead.leadType || '-',
    'Source Of Lead': lead.sourceOfLead || '-',
    'Pending Days': lead.pendingDays ?? '-',
  }));